
import { MapLocation } from '@/types/location';

// Power Stage Gym Locations
export const powerStageGyms: MapLocation[] = [
  {
    id: 25001,
    name: "Power Stage Gym - Jeddah (Al Sharafeyah)",
    type: "Gym",
    devices: 3,
    coordinates: [21.512689781070065, 39.186400215035015],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
